import { render, staticRenderFns } from "./MergeLeads.vue?vue&type=template&id=d0418736&"
import script from "./MergeLeads.vue?vue&type=script&lang=js&"
export * from "./MergeLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports